import { render } from "./App.vue?vue&type=template&id=b9f86d28"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b9f86d28&lang=scss"

import exportComponent from "/Users/hhz/Desktop/project/patriot_games/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__